// import 'viem/window';

import {
  createPublicClient,
  createWalletClient,
  custom,
  EIP1193Provider,
  http,
} from 'viem';
import { base, baseSepolia } from 'viem/chains';

import { ENABLE_TESTNET, RPC_BASE } from '../../constants';

const noopProvider = { request: () => null } as unknown as EIP1193Provider;
const provider =
  typeof window !== 'undefined' && window?.ethereum
    ? window?.ethereum!
    : noopProvider;

export const networks = ENABLE_TESTNET ? [baseSepolia] : [base];

export const publicWallet = createPublicClient({
  chain: networks[0],
  transport: http(RPC_BASE),
});

export const clientWallet = createWalletClient({
  chain: networks[0],
  transport: custom(provider),
});
